<template>
  <div class="obf" :class="'is-' + phase">
    <div class="obf__bg" aria-hidden="true">
      <div class="obf__glow obf__glow--1" />
      <div class="obf__glow obf__glow--2" />
    </div>

    <div class="obf__head">
      <div class="obf__banner">{{ confirmed ? '开奖揭晓' : label }}</div>
      <div v-if="prizeName && !confirmed" class="obf__prize-name">{{ prizeName }}</div>
    </div>

    <!-- 待机盲盒环绕漂浮；抽奖中向中心收拢并加速抖动 -->
    <div v-if="phase !== 'reveal'" class="obf__stage" :class="{ 'is-open': phase === 'pending' }">
      <div v-for="n in 10" :key="'box-' + n" class="obf__box" :style="floatStyle(n)">
        <span class="obf__mark">?</span>
      </div>
      <div class="obf__hero">
        <img v-if="boxIcon" class="obf__hero-img" :src="boxIcon" alt="" />
        <div v-else class="obf__hero-drawn"><span class="obf__mark">?</span></div>
        <p>{{ phase === 'pending' ? '开盒中…' : '盲盒待开启' }}</p>
      </div>
      <div v-if="phase === 'pending'" class="obf__drawing">
        <span class="obf__drawing-text">开盒中</span>
      </div>
    </div>

    <!-- 确认后居中揭晓奖品 -->
    <div v-else class="obf__reveal">
      <div class="obf__card">
        <div class="obf__card-label">恭喜开出</div>
        <div class="obf__prize">
          <img v-if="prizeImage" :src="prizeImage" alt="" />
          <span v-else class="obf__prize-mark">?</span>
        </div>
        <div class="obf__winner-name">{{ winner.nick || winner.uid || '幸运嘉宾' }}</div>
        <div v-if="prizeName" class="obf__winner-prize">{{ prizeName }}</div>
      </div>
    </div>

    <div class="obf__foot">已入场 {{ onlineCount || 0 }} 人 · 盲盒 {{ BOX_COUNT }} 个</div>
  </div>
</template>

<script>
import { PARTY_GAME_ICONS, PARTY_PRIZE_FALLBACK } from '../partyAssets'

const FLOAT_ANGLES = [0, 36, 72, 108, 144, 180, 216, 252, 288, 324]
const BOX_COUNT = FLOAT_ANGLES.length

export default {
  name: 'OpenBoxFx',
  props: {
    guests: { type: Array, default: () => [] },
    draft: { type: Object, default: null },
    h5: { type: Object, default: () => ({}) },
    onlineCount: { type: Number, default: 0 },
    label: { type: String, default: '开盲盒抽奖' }
  },
  data() {
    return { BOX_COUNT }
  },
  computed: {
    phase() {
      const status = (this.draft && this.draft.status) || ''
      if (status === 'confirmed') return 'reveal'
      if (status === 'pending') return 'pending'
      return 'idle'
    },
    confirmed() {
      return !!(this.draft && this.draft.status === 'confirmed')
    },
    winner() {
      const d = this.draft || {}
      if (d.winner) return d.winner
      if (Array.isArray(d.winners) && d.winners.length) return d.winners[0]
      return {}
    },
    prizeName() {
      return (this.draft && this.draft.prizeName) || ''
    },
    prizeImage() {
      if (this.draft && this.draft.prizeImage) return this.draft.prizeImage
      return PARTY_PRIZE_FALLBACK
    },
    boxIcon() {
      return PARTY_GAME_ICONS.open_box
    }
  },
  methods: {
    floatStyle(n) {
      const angle = FLOAT_ANGLES[(n - 1) % FLOAT_ANGLES.length]
      return {
        transform:
          'translate(-50%, -50%) rotate(' + angle + 'deg) translateY(calc(var(--obf-spread) * -1)) rotate(-' + angle + 'deg)',
        animationDelay: ((n - 1) * 0.25) + 's'
      }
    }
  }
}
</script>

<style scoped>
.obf {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: #fff7ef;
  --obf-spread: 40vh;
}
.obf.is-pending {
  --obf-spread: 14vh;
}
.obf__bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 45%, #4a1c12 0%, #1a0d16 62%, #0b0610 100%);
  overflow: hidden;
}
.obf__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.5;
}
.obf__glow--1 {
  width: 40vw;
  height: 40vw;
  left: 8%;
  top: 14%;
  background: rgba(255, 120, 40, 0.42);
  animation: obfFloat 9s ease-in-out infinite alternate;
}
.obf__glow--2 {
  width: 32vw;
  height: 32vw;
  right: 8%;
  bottom: 10%;
  background: rgba(255, 200, 80, 0.32);
  animation: obfFloat 11s ease-in-out infinite alternate-reverse;
}
.obf__head {
  position: relative;
  z-index: 20;
  padding-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}
.obf__banner {
  display: inline-block;
  padding: 8px 36px;
  border-radius: 24px;
  background: linear-gradient(90deg, #ff8a3d, #ff4d6d);
  font-size: 28px;
  letter-spacing: 4px;
  box-shadow: 0 0 24px rgba(255, 130, 60, 0.55);
}
.obf__prize-name {
  display: inline-block;
  padding: 8px 30px;
  border-radius: 999px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #ffe6a0;
  background: rgba(20, 8, 10, 0.62);
  border: 1px solid rgba(255, 214, 102, 0.55);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.45), 0 0 18px rgba(255, 200, 70, 0.25);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.9);
}
.obf__stage {
  position: absolute;
  inset: 0;
}
.obf__box {
  position: absolute;
  left: 50%;
  top: 52%;
  width: 74px;
  height: 74px;
  border-radius: 14px;
  background: linear-gradient(160deg, #ffb35c 0%, #e0631f 100%);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: obfBob 3.4s ease-in-out infinite;
  transition: transform 0.9s cubic-bezier(0.22, 0.8, 0.28, 1);
}
.obf__stage.is-open .obf__box {
  animation-duration: 1.1s;
}
.obf__mark {
  font-size: 30px;
  font-weight: 800;
  color: #fff7ef;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}
.obf__hero {
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.obf__hero-img {
  width: min(26vh, 260px);
  height: auto;
  animation: obfShake 1.4s ease-in-out infinite;
}
.obf__stage.is-open .obf__hero-img {
  animation-duration: 0.55s;
}
.obf__hero-drawn {
  width: min(24vh, 220px);
  height: min(24vh, 220px);
  border-radius: 28px;
  background: linear-gradient(160deg, #ffb35c 0%, #e0631f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 60px rgba(255, 160, 60, 0.45);
  animation: obfShake 1.4s ease-in-out infinite;
}
.obf__hero-drawn .obf__mark {
  font-size: 96px;
}
.obf__hero p {
  margin-top: 24px;
  padding: 8px 26px;
  border-radius: 999px;
  font-size: 22px;
  letter-spacing: 3px;
  color: #fff;
  background: rgba(20, 8, 10, 0.6);
  border: 1px solid rgba(255, 190, 120, 0.35);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.9);
}
.obf__drawing {
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  z-index: 40;
  padding: 12px 48px 16px;
  border-radius: 32px;
  pointer-events: none;
  white-space: nowrap;
  background: rgba(28, 8, 6, 0.76);
  border: 2px solid rgba(255, 190, 120, 0.5);
  box-shadow: 0 0 48px rgba(255, 150, 60, 0.45), 0 12px 30px rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.obf__drawing-text {
  font-size: 64px;
  font-weight: 800;
  letter-spacing: 8px;
  background: linear-gradient(90deg, #ffd76a, #ff8a3d, #ff4d6d);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: obfPulse 0.9s ease-in-out infinite;
}
.obf__reveal {
  position: absolute;
  left: 50%;
  top: 54%;
  transform: translate(-50%, -50%);
  z-index: 30;
  animation: obfPop 0.6s cubic-bezier(0.2, 0.9, 0.3, 1.2) both;
}
.obf__card {
  width: 420px;
  padding: 18px 22px 24px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: linear-gradient(180deg, rgba(150, 60, 20, 0.95), rgba(40, 12, 16, 0.96));
  border: 3px solid #ffd76a;
  box-shadow: 0 0 60px rgba(255, 180, 70, 0.55), 0 20px 60px rgba(0, 0, 0, 0.45);
}
.obf__card-label {
  margin: 0 0 12px;
  font-size: 24px;
  letter-spacing: 4px;
  color: #ffd76a;
}
.obf__prize {
  width: min(230px, 26vh);
  height: min(230px, 26vh);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle, rgba(255, 199, 88, 0.28) 0%, rgba(26, 13, 22, 0.85) 70%);
  border: 3px solid rgba(255, 255, 255, 0.85);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.obf__prize img {
  width: 88%;
  height: 88%;
  object-fit: contain;
}
.obf__prize-mark {
  font-size: 96px;
  font-weight: 800;
  color: #ffe6c4;
}
.obf__winner-name {
  margin-top: 14px;
  font-size: 38px;
  line-height: 1.25;
  font-weight: 800;
  text-shadow: 0 0 18px rgba(255, 220, 120, 0.6);
}
.obf__winner-prize {
  margin-top: 6px;
  font-size: 20px;
  line-height: 1.3;
  color: #ffe6a5;
}
.obf__foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  z-index: 20;
  text-align: center;
  font-size: 16px;
  color: #fff1e4;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.95), 0 0 24px rgba(0, 0, 0, 0.8);
}
@keyframes obfBob {
  0%, 100% { margin-top: 0; }
  50% { margin-top: -16px; }
}
@keyframes obfShake {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-5deg); }
  75% { transform: rotate(5deg); }
}
@keyframes obfPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.08); opacity: 0.85; }
}
@keyframes obfFloat {
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(3%, 4%) scale(1.12); }
}
@keyframes obfPop {
  0% { opacity: 0; transform: translate(-50%, -50%) scale(0.62); }
  100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}
</style>
